import { gql } from "graphql-tag"

const typeArticleRef = gql`
  type ArticleRef {
    id: ID!
    sku: ID
    sdbSKU: ID

    title: String
    altTitle: String

    ean: String
    altEAN: String

    amount: Float
    contents: String
    container: String
    status: String

    color: String
    baseColor: String
    brand: String

    mix: Boolean
    deleted: Boolean
    sale: Boolean
    hidden: Boolean

    articleMainGroup: ArticleMainGroup
    articleGroup: ArticleGroup
    packageUnitPerCarton: String
    packageUnitPerPallet: String
    containerPerPallet: Float
    searchTermThree: String
    searchTermFour: String

    price: ListPrice
    attributes: [JSONObject]

    customerPrice: CustomerPrice!
    articleInfo: String
    availability: String
    amountBilling: String
    sellableInDecimals: Boolean
  }
`

export { typeArticleRef }

export default typeArticleRef
